import React, { useState, FC } from 'react';
import { IconButton, Box, Typography, Grid, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import WakeUp from '../wake-up';
import DeviceLabel from '../../device-label';
import SearchBar from '../../search-bar';

import DeleteIcon from '../../../assets/icons/delete-icon';
import ReloadIcon from '../../../assets/icons/reload-icon';
import useStyles from '../../../pages/configure/styles';
import { AppState } from '../../../store';
import { updateCommandsByDeviceKey, pollCommandsByDeviceKey } from '../../../store/commands/actions';
import { Command } from '../../../entities/commands-v1/command';
import ConfigurationAccordions from '../configurations-accordions';
import ConfigurationTable, { FormattedRow } from './table';
import theme from '../../../globals/theme';

const NonOrbcommDevices: FC = () => {
  const dispatch = useDispatch();
  const deviceKey = useSelector((state: AppState) => state.search.selectedEntity?.deviceKey);
  const commands: Command[] = useSelector((state: AppState) => state.commands.commands);
  const [selectedCommands, setSelectedCommands] = useState([]);
  const [queueCount, setQueueCount] = useState(0);
  const { client } = useSelector((state: AppState) => state.login);
  const clientAuth: any = client?.authenticate();
  const userName = clientAuth.loginId;
  const classes = useStyles();

  const deleteSelectedCommands = (
    selectedCommands: FormattedRow[],
    allCommands: Array<Command>,
  ) => {
    const commandsForDelete = allCommands
      .filter(
        (command: Command) =>
          selectedCommands.findIndex(
            (selectedCommand) => selectedCommand.id === command.commandId,
          ) !== -1,
      )
      .map((filteredCommands: Command) => ({
        sequenceNumber: filteredCommands.sequenceNumber,
        commandId: filteredCommands.commandId,
        status: 23,
        modifiedBy: userName
      }));
    if (deviceKey) {
      dispatch(
        updateCommandsByDeviceKey({
          deviceKey,
          body: commandsForDelete,
        }),
      );
    }
  };

  return (
    <Box px={5} className={classes.scrollContainer}>
      {!deviceKey ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="calc(100vh - 5vh - 64px)"
          paddingBottom="5vh"
        >
          <SearchBar page="/configure" />
        </Box>
      ) : (
        <Box mb={4} pb={1}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <DeviceLabel />
            <WakeUp />
          </Box>
          <Box display="flex" flexDirection="row" alignItems="flex-end">
            <Grid container>
              <Grid item md={8}>
                <Box pt={3} pb={1.5} display="flex" justifyContent="flex-start" alignItems="center">
                  <Typography variant="h6">Command Queue</Typography>
                  {selectedCommands.length > 0 && (
                    <IconButton
                      id="deleteButton"
                      onClick={() => deleteSelectedCommands(selectedCommands, commands)}
                      className={classes.deleteIcon}
                      aria-label="delete"
                      size="large">
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
              </Grid>
              <Grid item md={4}>
                <Box pt={3} pb={1.5} display="flex" justifyContent="flex-end" alignItems="center">
                  <Tooltip title="Refresh Command Queue" enterDelay={600}>
                    <span>
                      <IconButton
                        id="refreshButton"
                        onClick={() => dispatch(pollCommandsByDeviceKey({ deviceKey, statuses: '1' }))}
                        aria-label="refresh"
                        size="small"
                      >
                        <ReloadIcon stroke={`${theme.palette.grey[600]}`} />
                      </IconButton>
                    </span>
                  </Tooltip>
                  {queueCount > 0 &&
                    <> Displaying&nbsp;<Typography variant="h6">last {queueCount} of {queueCount}</Typography>&nbsp;Total Queued Commands.</>
                  }
                  {queueCount === 0 &&
                    <> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
                  }
                </Box>
              </Grid>
            </Grid>
          </Box>
          <ConfigurationTable onRowSelection={(row: any) => setSelectedCommands(row)} setQueueCount={(queueCount: number) => setQueueCount(queueCount)} queueCount={queueCount} />
          <ConfigurationAccordions />
        </Box>
      )}
    </Box>
  );
};

export default NonOrbcommDevices;
